<template>
    <div
      id="reports"
      class="row"
    >
      <div class="col-12">
        <v-col
          v-if="dowloading"
          class="subtitle-1 text-center"
          cols="12"
        > Cargando por favor espere...
        </v-col>
        <v-progress-linear
          indeterminate
          :background-color="backgroundLoadingColor"
          :color="loadingColor"
          height="10"
          v-if="dowloading"
        ></v-progress-linear>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="reset"
          @keydown="form.onKeydown($event)"
        >
          <v-container grid-list-xl>
            <toolbar
              :title="title"
              :loading="form.busy"
              :buttons="buttons"
              @getDocuments="getDocuments"
              @downloadExcel="downloadExcel"
            />
            <v-layout
              :id="ref"
              class="wrap justify-space-around form-body"
            >
            <v-col lg="2" md="2" sm="2" cols="12">
                <v-menu
                    v-model="form.dateMenu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="computedDateFormattedStart"
                        label="Fecha Inicio"
                        :rules="[rules.required]"
                        required
                        readonly
                        hide-details
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-col cols="12" style="padding: 0 !important;">
                      <v-date-picker
                        :color="themeColor"
                        :max="form.dateMax"
                        v-model="form.dateStart"
                        @input="form.dateMenu1 = false"
                      />
                    </v-col>
                    <v-col cols="12" sm="12" style="padding: 0 !important;">
                      <v-btn
                        block
                        :color="themeColor"
                        dark
                        @click="today('one')"
                      >
                        HOY
                      </v-btn>
                    </v-col>
                  </v-menu>
              </v-col>
              <v-col lg="2" md="2" sm="2" cols="12">
                <v-menu
                    v-model="form.dateMenu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="computedDateFormattedEnd"
                        label="Fecha Fin"
                        :rules="[rules.required]"
                        required
                        readonly
                        hide-details
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-col cols="12" style="padding: 0 !important;">
                      <v-date-picker
                        :color="themeColor"
                        v-model="form.dateEnd"
                        :max="form.dateMax"
                        @input="form.dateMenu2 = false"
                      />
                    </v-col>
                    <v-col cols="12" style="padding: 0 !important;">
                      <v-btn
                        block
                        :color="themeColor"
                        dark
                        @click="today('two')"
                      >
                        HOY
                      </v-btn>
                    </v-col>
                  </v-menu>
              </v-col>
            </v-layout>
          </v-container>
        </v-form>
      </div>
      <div class="col-12">
        <v-data-table
          v-if="documents !== 0 && form.ext === false"
          :headers="headers"
          :items="documents"
          :class="`elevation-1 ${navbarColor}`"
        >
        </v-data-table>
        <v-data-table
          v-if="documents !== 0 && form.ext === true"
          :headers="headers"
          :items="documents"
          :class="`elevation-1 ${navbarColor}`"
        >
        </v-data-table>
      </div>
    </div>
  </template>
  <script>

  import Form from 'vform';
  import { mask } from 'vue-the-mask';
  import { mapGetters } from 'vuex';
  import moment from 'moment';
  import { format, parseISO } from 'date-fns';
  import Toolbar from '~/components/Toolbar';
  import 'vuetify/src/styles/main.sass';

  Form.axios = window.axios;
  export default {
    middleware: 'auth',
    metaInfo() {
      return { title: this.$t('reportArt') };
    },
    components: {
      Toolbar,
    },
    computed: {
      ref() {
        return this.form.id;
      },
      ...mapGetters({
        user: 'auth/user',
        loadingColor: 'theme/loadingColor',
        backgroundLoadingColor: 'theme/backgroundLoadingColor',
        navbarColor: 'theme/navbarColor',
        themeColor: 'theme/themeColor',
      }),
      computedDateFormattedStart() {
          return this.form.dateStart ? moment(this.form.dateStart).format('DD-MM-YYYY') : '';
      },
      computedDateFormattedEnd() {
          return this.form.dateEnd ? format(parseISO(this.form.dateEnd), 'dd-MM-yyyy') : '';
      },
    },
    directives: {
        mask,
      },
    data: () => ({
      title: 'Reporte Artículo 32',
      form: new Form({
        busy: false,
        dateStart: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        dateEnd: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        dateMax: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        dateMenu1: false,
        dateMenu2: false,
        dateAnnulment: '',
        typePortal: 'A',
        enterpriseId: '',
        ext: false,
      }),
      valid: false,
      label: 'Por Defecto',
      rules: {
        required: (v) => !!v || 'El campo es requerido.',
      },
      allHeaders: [
      {
        text: 'Nombre del Emisor',
        value: 'Empresa',
        align: 'left',
        sortable: true,
      },
      {
        text: 'RIF',
        value: 'RIF_Emisor',
        align: 'left',
        sortable: true,
      }, {
        text: 'Serie',
        value: 'Serie',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Desde',
        value: 'Desde',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Hasta',
        value: 'Hasta',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Total de NIKKON Asignados',
        value: 'Emisiones_Periodo',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Facturas',
        value: 'Facturas',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Notas Debito',
        value: 'Notas_Debito',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Notas Credito',
        value: 'Notas_Credito',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Guias Despacho',
        value: 'Guias_Despacho',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Comprobantes IVA',
        value: 'Comprobantes_IVA',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Comprobantes ISLR',
        value: 'Comprobantes_ISLR',
        align: 'left',
        sortable: true,
      },
      {
        text: 'N° de Factura de la Imprenta Digital',
        value: 'Factura_Emitida',
        align: 'left',
        sortable: true,
      },
    ],
    allHeadersNew: [
      {
        text: 'Número de control',
        value: 'control_number',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Numero de documento',
        value: 'number_document',
        align: 'left',
        sortable: true,
      }, {
        text: 'Fecha de asignación',
        value: 'Fecha_Asignacion',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Fecha de emisión',
        value: 'Fecha_Emision',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Serie',
        value: 'SERIE',
        align: 'left',
        sortable: true,
      },
    ],
      documents: 0,
      dowloading: false,
      buttons: [
        {
            id: 'save',
            icon: 'mdi-file-find',
            name: 'Generar Vista Previa',
            event: 'getDocuments',
            color: 'blue darken-1',
         },
        {
          id: 'cancel',
          icon: 'mdi-download',
          name: 'Descargar Excel',
          event: 'downloadExcel',
          color: 'green',
        },
      ],
      cat_province_id: '',
    }),
    beforeMount() {
      if (this.user.role === 4 || this.user.role === 5) {
        this.allHeaders.splice(this.allHeaders.findIndex(({ value }) => value === 'Emisiones_Periodo'), 1);
      }
    },
    mounted() {
      this.form.dateStart = moment(this.dateStart).subtract(7, 'days').format('YYYY-MM-DD');
    },
    methods: {
      getDocuments() {
          const dateRange = moment(this.form.dateEnd).diff(this.form.dateStart, 'month', true);
          if (dateRange > 1) {
            this.$store.dispatch('notifications/show', {
                  message: 'El rango de consulta no debe ser mayor a un mes',
                  type: 'error',
            });
          } else if (this.form.dateEnd < this.form.dateStart) {
            this.$store.dispatch('notifications/show', {
              message: 'La fecha fin no debe ser menor a la fecha inicio',
              type: 'error',
            });
        } else if (this.form.ext === true && this.$store.state.taxpayer.id === null) {
            this.$store.dispatch('notifications/show', {
                  message: 'Seleccione el Nº Indentificación del Emisor o Razón Social',
                  type: 'error',
              });
        } else {
            this.validate();
            if (this.$refs.form.validate()) {
              this.dowloading = true;
              this.form.enterpriseId = this.$store.state.taxpayer.id;
              const filteredFields = [];
              const url = '/api/getArt';
              this.form.post(url).then((response) => {
                this.documents = response.data;
                if (this.form.ext === false) {
                  this.headers = this.allHeaders;
                } else {
                  this.headers = this.allHeadersNew;
                }
                this.headers = this.headers.filter((header) => filteredFields.indexOf(header.text) === -1);
                setTimeout(() => { this.dowloading = false; }, 500);
              })
              .catch(() => {
              });
            }
          }
      },
        getReport() {
          const url = '/api/reportIssued/generateIssued';
          return window.axios({
            method: 'post',
            url,
            data: this.form,
          }).catch((e) => {
            // eslint-disable-next-line
            console.log(e);
            this.downloading = false;
            this.form.busy = false;
          });
        },
     downloadExcel() {
          if (!this.documents) {
                this.$store.dispatch('notifications/show', {
                  message: 'El archivo NO contiene registros que coincidan con los criterios de búsqueda.',
                  type: 'error',
                });
              } else {
                this.dowloading = true;
                  this.form.enterpriseId = this.$store.state.taxpayer.id;
                  const url = '/api/reportArt/export';
                  return window.axios({
                      method: 'post',
                      url,
                      data: this.form,
                    }).catch((e) => {
                      // eslint-disable-next-line
                      console.log(e);
                      this.downloading = false;
                      this.form.busy = false;
                    }).then((response) => {
                      this.downloadFile(response, `Reporte Art. 32  ${new Date().toISOString().slice(0, 10)}`);
                      setTimeout(() => { this.dowloading = false; }, 1000);
                  });
              }
      },
      downloadFile(response, filename) {
        const newBlob = new Blob([atob(response.data.file)], { type: 'csv' });
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }
        const data = window.URL.createObjectURL(newBlob);
        const link = document.createElement('a');
        link.href = data;
        link.download = `${filename}.csv`;
        link.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(data);
        }, 100);
      },
      validate() {
        if (this.$refs.form.validate()) {
          this.snackbar = true;
          this.form.busy = true;
          if (this.$store.state.taxpayer.rif === null) {
            this.valid = false;
          } else {
            this.valid = true;
          }
        }
      },
      today(menu) {
        if (menu === 'one') {
          this.form.dateStart = format(parseISO(new Date().toISOString()), 'yyyy-MM-dd');
          this.form.dateMenu1 = false;
        } else {
          this.form.dateEnd = format(parseISO(new Date().toISOString()), 'yyyy-MM-dd');
          this.form.dateMenu2 = false;
        }
      },
    },
  };
  </script>
